import xt, { createContext as Ca, useContext as Ra, useState as It, useCallback as Sa, useLayoutEffect as Pr } from "react";
const Tn = (r) => {
  var t, a;
  return typeof r == "string" ? r : !r || typeof r != "object" ? "Unknown error object" : "message" in r ? r.message ?? "Unknown error" : "response" in r ? ((a = (t = r.response) == null ? void 0 : t.data) == null ? void 0 : a.message) ?? "Unknown API error" : "Unknown error format";
};
var Ta = /* @__PURE__ */ ((r) => (r.STUDENTS_APPLICATIONS = "Students_Applications", r.CONTACTS = "Contacts", r.ACCOUNTS = "Accounts", r.DEALS = "Deals", r))(Ta || {}), Ea = /* @__PURE__ */ ((r) => (r.STUDENT_CONTACT = "Student", r.DEAL = "Deal", r))(Ea || {}), qa = /* @__PURE__ */ ((r) => (r.B2C = "B2C", r.B2B = "B2B", r))(qa || {}), H = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Oa(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var re, Dr;
function er() {
  if (Dr) return re;
  Dr = 1;
  var r = Array.isArray;
  return re = r, re;
}
var te, xr;
function wa() {
  if (xr) return te;
  xr = 1;
  var r = typeof H == "object" && H && H.Object === Object && H;
  return te = r, te;
}
var ae, Ir;
function rr() {
  if (Ir) return ae;
  Ir = 1;
  var r = wa(), t = typeof self == "object" && self && self.Object === Object && self, a = r || t || Function("return this")();
  return ae = a, ae;
}
var ne, kr;
function tr() {
  if (kr) return ne;
  kr = 1;
  var r = rr(), t = r.Symbol;
  return ne = t, ne;
}
var ie, Ar;
function ja() {
  if (Ar) return ie;
  Ar = 1;
  var r = tr(), t = Object.prototype, a = t.hasOwnProperty, i = t.toString, u = r ? r.toStringTag : void 0;
  function n(c) {
    var f = a.call(c, u), v = c[u];
    try {
      c[u] = void 0;
      var g = !0;
    } catch {
    }
    var m = i.call(c);
    return g && (f ? c[u] = v : delete c[u]), m;
  }
  return ie = n, ie;
}
var oe, Fr;
function Pa() {
  if (Fr) return oe;
  Fr = 1;
  var r = Object.prototype, t = r.toString;
  function a(i) {
    return t.call(i);
  }
  return oe = a, oe;
}
var ue, Mr;
function kt() {
  if (Mr) return ue;
  Mr = 1;
  var r = tr(), t = ja(), a = Pa(), i = "[object Null]", u = "[object Undefined]", n = r ? r.toStringTag : void 0;
  function c(f) {
    return f == null ? f === void 0 ? u : i : n && n in Object(f) ? t(f) : a(f);
  }
  return ue = c, ue;
}
var se, Gr;
function Da() {
  if (Gr) return se;
  Gr = 1;
  function r(t) {
    return t != null && typeof t == "object";
  }
  return se = r, se;
}
var ce, $r;
function ar() {
  if ($r) return ce;
  $r = 1;
  var r = kt(), t = Da(), a = "[object Symbol]";
  function i(u) {
    return typeof u == "symbol" || t(u) && r(u) == a;
  }
  return ce = i, ce;
}
var fe, Nr;
function xa() {
  if (Nr) return fe;
  Nr = 1;
  var r = er(), t = ar(), a = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, i = /^\w*$/;
  function u(n, c) {
    if (r(n))
      return !1;
    var f = typeof n;
    return f == "number" || f == "symbol" || f == "boolean" || n == null || t(n) ? !0 : i.test(n) || !a.test(n) || c != null && n in Object(c);
  }
  return fe = u, fe;
}
var le, zr;
function At() {
  if (zr) return le;
  zr = 1;
  function r(t) {
    var a = typeof t;
    return t != null && (a == "object" || a == "function");
  }
  return le = r, le;
}
var ve, Hr;
function Ia() {
  if (Hr) return ve;
  Hr = 1;
  var r = kt(), t = At(), a = "[object AsyncFunction]", i = "[object Function]", u = "[object GeneratorFunction]", n = "[object Proxy]";
  function c(f) {
    if (!t(f))
      return !1;
    var v = r(f);
    return v == i || v == u || v == a || v == n;
  }
  return ve = c, ve;
}
var de, Lr;
function ka() {
  if (Lr) return de;
  Lr = 1;
  var r = rr(), t = r["__core-js_shared__"];
  return de = t, de;
}
var he, Vr;
function Aa() {
  if (Vr) return he;
  Vr = 1;
  var r = ka(), t = function() {
    var i = /[^.]+$/.exec(r && r.keys && r.keys.IE_PROTO || "");
    return i ? "Symbol(src)_1." + i : "";
  }();
  function a(i) {
    return !!t && t in i;
  }
  return he = a, he;
}
var pe, Kr;
function Fa() {
  if (Kr) return pe;
  Kr = 1;
  var r = Function.prototype, t = r.toString;
  function a(i) {
    if (i != null) {
      try {
        return t.call(i);
      } catch {
      }
      try {
        return i + "";
      } catch {
      }
    }
    return "";
  }
  return pe = a, pe;
}
var _e, Wr;
function Ma() {
  if (Wr) return _e;
  Wr = 1;
  var r = Ia(), t = Aa(), a = At(), i = Fa(), u = /[\\^$.*+?()[\]{}|]/g, n = /^\[object .+?Constructor\]$/, c = Function.prototype, f = Object.prototype, v = c.toString, g = f.hasOwnProperty, m = RegExp(
    "^" + v.call(g).replace(u, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function T(E) {
    if (!a(E) || t(E))
      return !1;
    var P = r(E) ? m : n;
    return P.test(i(E));
  }
  return _e = T, _e;
}
var ge, Yr;
function Ga() {
  if (Yr) return ge;
  Yr = 1;
  function r(t, a) {
    return t == null ? void 0 : t[a];
  }
  return ge = r, ge;
}
var ye, Ur;
function Ft() {
  if (Ur) return ye;
  Ur = 1;
  var r = Ma(), t = Ga();
  function a(i, u) {
    var n = t(i, u);
    return r(n) ? n : void 0;
  }
  return ye = a, ye;
}
var be, Jr;
function V() {
  if (Jr) return be;
  Jr = 1;
  var r = Ft(), t = r(Object, "create");
  return be = t, be;
}
var me, Br;
function $a() {
  if (Br) return me;
  Br = 1;
  var r = V();
  function t() {
    this.__data__ = r ? r(null) : {}, this.size = 0;
  }
  return me = t, me;
}
var Ce, Xr;
function Na() {
  if (Xr) return Ce;
  Xr = 1;
  function r(t) {
    var a = this.has(t) && delete this.__data__[t];
    return this.size -= a ? 1 : 0, a;
  }
  return Ce = r, Ce;
}
var Re, Zr;
function za() {
  if (Zr) return Re;
  Zr = 1;
  var r = V(), t = "__lodash_hash_undefined__", a = Object.prototype, i = a.hasOwnProperty;
  function u(n) {
    var c = this.__data__;
    if (r) {
      var f = c[n];
      return f === t ? void 0 : f;
    }
    return i.call(c, n) ? c[n] : void 0;
  }
  return Re = u, Re;
}
var Se, Qr;
function Ha() {
  if (Qr) return Se;
  Qr = 1;
  var r = V(), t = Object.prototype, a = t.hasOwnProperty;
  function i(u) {
    var n = this.__data__;
    return r ? n[u] !== void 0 : a.call(n, u);
  }
  return Se = i, Se;
}
var Te, et;
function La() {
  if (et) return Te;
  et = 1;
  var r = V(), t = "__lodash_hash_undefined__";
  function a(i, u) {
    var n = this.__data__;
    return this.size += this.has(i) ? 0 : 1, n[i] = r && u === void 0 ? t : u, this;
  }
  return Te = a, Te;
}
var Ee, rt;
function Va() {
  if (rt) return Ee;
  rt = 1;
  var r = $a(), t = Na(), a = za(), i = Ha(), u = La();
  function n(c) {
    var f = -1, v = c == null ? 0 : c.length;
    for (this.clear(); ++f < v; ) {
      var g = c[f];
      this.set(g[0], g[1]);
    }
  }
  return n.prototype.clear = r, n.prototype.delete = t, n.prototype.get = a, n.prototype.has = i, n.prototype.set = u, Ee = n, Ee;
}
var qe, tt;
function Ka() {
  if (tt) return qe;
  tt = 1;
  function r() {
    this.__data__ = [], this.size = 0;
  }
  return qe = r, qe;
}
var Oe, at;
function Wa() {
  if (at) return Oe;
  at = 1;
  function r(t, a) {
    return t === a || t !== t && a !== a;
  }
  return Oe = r, Oe;
}
var we, nt;
function K() {
  if (nt) return we;
  nt = 1;
  var r = Wa();
  function t(a, i) {
    for (var u = a.length; u--; )
      if (r(a[u][0], i))
        return u;
    return -1;
  }
  return we = t, we;
}
var je, it;
function Ya() {
  if (it) return je;
  it = 1;
  var r = K(), t = Array.prototype, a = t.splice;
  function i(u) {
    var n = this.__data__, c = r(n, u);
    if (c < 0)
      return !1;
    var f = n.length - 1;
    return c == f ? n.pop() : a.call(n, c, 1), --this.size, !0;
  }
  return je = i, je;
}
var Pe, ot;
function Ua() {
  if (ot) return Pe;
  ot = 1;
  var r = K();
  function t(a) {
    var i = this.__data__, u = r(i, a);
    return u < 0 ? void 0 : i[u][1];
  }
  return Pe = t, Pe;
}
var De, ut;
function Ja() {
  if (ut) return De;
  ut = 1;
  var r = K();
  function t(a) {
    return r(this.__data__, a) > -1;
  }
  return De = t, De;
}
var xe, st;
function Ba() {
  if (st) return xe;
  st = 1;
  var r = K();
  function t(a, i) {
    var u = this.__data__, n = r(u, a);
    return n < 0 ? (++this.size, u.push([a, i])) : u[n][1] = i, this;
  }
  return xe = t, xe;
}
var Ie, ct;
function Xa() {
  if (ct) return Ie;
  ct = 1;
  var r = Ka(), t = Ya(), a = Ua(), i = Ja(), u = Ba();
  function n(c) {
    var f = -1, v = c == null ? 0 : c.length;
    for (this.clear(); ++f < v; ) {
      var g = c[f];
      this.set(g[0], g[1]);
    }
  }
  return n.prototype.clear = r, n.prototype.delete = t, n.prototype.get = a, n.prototype.has = i, n.prototype.set = u, Ie = n, Ie;
}
var ke, ft;
function Za() {
  if (ft) return ke;
  ft = 1;
  var r = Ft(), t = rr(), a = r(t, "Map");
  return ke = a, ke;
}
var Ae, lt;
function Qa() {
  if (lt) return Ae;
  lt = 1;
  var r = Va(), t = Xa(), a = Za();
  function i() {
    this.size = 0, this.__data__ = {
      hash: new r(),
      map: new (a || t)(),
      string: new r()
    };
  }
  return Ae = i, Ae;
}
var Fe, vt;
function en() {
  if (vt) return Fe;
  vt = 1;
  function r(t) {
    var a = typeof t;
    return a == "string" || a == "number" || a == "symbol" || a == "boolean" ? t !== "__proto__" : t === null;
  }
  return Fe = r, Fe;
}
var Me, dt;
function W() {
  if (dt) return Me;
  dt = 1;
  var r = en();
  function t(a, i) {
    var u = a.__data__;
    return r(i) ? u[typeof i == "string" ? "string" : "hash"] : u.map;
  }
  return Me = t, Me;
}
var Ge, ht;
function rn() {
  if (ht) return Ge;
  ht = 1;
  var r = W();
  function t(a) {
    var i = r(this, a).delete(a);
    return this.size -= i ? 1 : 0, i;
  }
  return Ge = t, Ge;
}
var $e, pt;
function tn() {
  if (pt) return $e;
  pt = 1;
  var r = W();
  function t(a) {
    return r(this, a).get(a);
  }
  return $e = t, $e;
}
var Ne, _t;
function an() {
  if (_t) return Ne;
  _t = 1;
  var r = W();
  function t(a) {
    return r(this, a).has(a);
  }
  return Ne = t, Ne;
}
var ze, gt;
function nn() {
  if (gt) return ze;
  gt = 1;
  var r = W();
  function t(a, i) {
    var u = r(this, a), n = u.size;
    return u.set(a, i), this.size += u.size == n ? 0 : 1, this;
  }
  return ze = t, ze;
}
var He, yt;
function on() {
  if (yt) return He;
  yt = 1;
  var r = Qa(), t = rn(), a = tn(), i = an(), u = nn();
  function n(c) {
    var f = -1, v = c == null ? 0 : c.length;
    for (this.clear(); ++f < v; ) {
      var g = c[f];
      this.set(g[0], g[1]);
    }
  }
  return n.prototype.clear = r, n.prototype.delete = t, n.prototype.get = a, n.prototype.has = i, n.prototype.set = u, He = n, He;
}
var Le, bt;
function un() {
  if (bt) return Le;
  bt = 1;
  var r = on(), t = "Expected a function";
  function a(i, u) {
    if (typeof i != "function" || u != null && typeof u != "function")
      throw new TypeError(t);
    var n = function() {
      var c = arguments, f = u ? u.apply(this, c) : c[0], v = n.cache;
      if (v.has(f))
        return v.get(f);
      var g = i.apply(this, c);
      return n.cache = v.set(f, g) || v, g;
    };
    return n.cache = new (a.Cache || r)(), n;
  }
  return a.Cache = r, Le = a, Le;
}
var Ve, mt;
function sn() {
  if (mt) return Ve;
  mt = 1;
  var r = un(), t = 500;
  function a(i) {
    var u = r(i, function(c) {
      return n.size === t && n.clear(), c;
    }), n = u.cache;
    return u;
  }
  return Ve = a, Ve;
}
var Ke, Ct;
function cn() {
  if (Ct) return Ke;
  Ct = 1;
  var r = sn(), t = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, a = /\\(\\)?/g, i = r(function(u) {
    var n = [];
    return u.charCodeAt(0) === 46 && n.push(""), u.replace(t, function(c, f, v, g) {
      n.push(v ? g.replace(a, "$1") : f || c);
    }), n;
  });
  return Ke = i, Ke;
}
var We, Rt;
function fn() {
  if (Rt) return We;
  Rt = 1;
  function r(t, a) {
    for (var i = -1, u = t == null ? 0 : t.length, n = Array(u); ++i < u; )
      n[i] = a(t[i], i, t);
    return n;
  }
  return We = r, We;
}
var Ye, St;
function ln() {
  if (St) return Ye;
  St = 1;
  var r = tr(), t = fn(), a = er(), i = ar(), u = r ? r.prototype : void 0, n = u ? u.toString : void 0;
  function c(f) {
    if (typeof f == "string")
      return f;
    if (a(f))
      return t(f, c) + "";
    if (i(f))
      return n ? n.call(f) : "";
    var v = f + "";
    return v == "0" && 1 / f == -1 / 0 ? "-0" : v;
  }
  return Ye = c, Ye;
}
var Ue, Tt;
function vn() {
  if (Tt) return Ue;
  Tt = 1;
  var r = ln();
  function t(a) {
    return a == null ? "" : r(a);
  }
  return Ue = t, Ue;
}
var Je, Et;
function dn() {
  if (Et) return Je;
  Et = 1;
  var r = er(), t = xa(), a = cn(), i = vn();
  function u(n, c) {
    return r(n) ? n : t(n, c) ? [n] : a(i(n));
  }
  return Je = u, Je;
}
var Be, qt;
function hn() {
  if (qt) return Be;
  qt = 1;
  var r = ar();
  function t(a) {
    if (typeof a == "string" || r(a))
      return a;
    var i = a + "";
    return i == "0" && 1 / a == -1 / 0 ? "-0" : i;
  }
  return Be = t, Be;
}
var Xe, Ot;
function pn() {
  if (Ot) return Xe;
  Ot = 1;
  var r = dn(), t = hn();
  function a(i, u) {
    u = r(u, i);
    for (var n = 0, c = u.length; i != null && n < c; )
      i = i[t(u[n++])];
    return n && n == c ? i : void 0;
  }
  return Xe = a, Xe;
}
var Ze, wt;
function _n() {
  if (wt) return Ze;
  wt = 1;
  var r = pn();
  function t(a, i, u) {
    var n = a == null ? void 0 : r(a, i);
    return n === void 0 ? u : n;
  }
  return Ze = t, Ze;
}
var gn = _n();
const Qe = /* @__PURE__ */ Oa(gn), En = (r) => ({
  appId: Qe(r, "userData.modules.Students_Applications[0]", ""),
  dealId: Qe(r, "userData.modules.Deals[0]", ""),
  contactId: Qe(r, "userData.modules.Contacts[0]", "")
}), qn = (r) => r.sub.replace("auth0|", ""), Mt = Ca(void 0), On = () => {
  const r = Ra(Mt);
  if (r === void 0)
    throw new Error("usePageTitle must be used within a PageTitleProvider");
  return r;
};
var L = { exports: {} }, F = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var jt;
function yn() {
  if (jt) return F;
  jt = 1;
  var r = xt, t = Symbol.for("react.element"), a = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, u = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, n = { key: !0, ref: !0, __self: !0, __source: !0 };
  function c(f, v, g) {
    var m, T = {}, E = null, P = null;
    g !== void 0 && (E = "" + g), v.key !== void 0 && (E = "" + v.key), v.ref !== void 0 && (P = v.ref);
    for (m in v) i.call(v, m) && !n.hasOwnProperty(m) && (T[m] = v[m]);
    if (f && f.defaultProps) for (m in v = f.defaultProps, v) T[m] === void 0 && (T[m] = v[m]);
    return { $$typeof: t, type: f, key: E, ref: P, props: T, _owner: u.current };
  }
  return F.Fragment = a, F.jsx = c, F.jsxs = c, F;
}
var M = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Pt;
function bn() {
  return Pt || (Pt = 1, process.env.NODE_ENV !== "production" && function() {
    var r = xt, t = Symbol.for("react.element"), a = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), u = Symbol.for("react.strict_mode"), n = Symbol.for("react.profiler"), c = Symbol.for("react.provider"), f = Symbol.for("react.context"), v = Symbol.for("react.forward_ref"), g = Symbol.for("react.suspense"), m = Symbol.for("react.suspense_list"), T = Symbol.for("react.memo"), E = Symbol.for("react.lazy"), P = Symbol.for("react.offscreen"), nr = Symbol.iterator, Gt = "@@iterator";
    function $t(e) {
      if (e === null || typeof e != "object")
        return null;
      var o = nr && e[nr] || e[Gt];
      return typeof o == "function" ? o : null;
    }
    var D = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function C(e) {
      {
        for (var o = arguments.length, s = new Array(o > 1 ? o - 1 : 0), l = 1; l < o; l++)
          s[l - 1] = arguments[l];
        Nt("error", e, s);
      }
    }
    function Nt(e, o, s) {
      {
        var l = D.ReactDebugCurrentFrame, p = l.getStackAddendum();
        p !== "" && (o += "%s", s = s.concat([p]));
        var _ = s.map(function(h) {
          return String(h);
        });
        _.unshift("Warning: " + o), Function.prototype.apply.call(console[e], console, _);
      }
    }
    var zt = !1, Ht = !1, Lt = !1, Vt = !1, Kt = !1, ir;
    ir = Symbol.for("react.module.reference");
    function Wt(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === i || e === n || Kt || e === u || e === g || e === m || Vt || e === P || zt || Ht || Lt || typeof e == "object" && e !== null && (e.$$typeof === E || e.$$typeof === T || e.$$typeof === c || e.$$typeof === f || e.$$typeof === v || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === ir || e.getModuleId !== void 0));
    }
    function Yt(e, o, s) {
      var l = e.displayName;
      if (l)
        return l;
      var p = o.displayName || o.name || "";
      return p !== "" ? s + "(" + p + ")" : s;
    }
    function or(e) {
      return e.displayName || "Context";
    }
    function O(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && C("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case i:
          return "Fragment";
        case a:
          return "Portal";
        case n:
          return "Profiler";
        case u:
          return "StrictMode";
        case g:
          return "Suspense";
        case m:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case f:
            var o = e;
            return or(o) + ".Consumer";
          case c:
            var s = e;
            return or(s._context) + ".Provider";
          case v:
            return Yt(e, e.render, "ForwardRef");
          case T:
            var l = e.displayName || null;
            return l !== null ? l : O(e.type) || "Memo";
          case E: {
            var p = e, _ = p._payload, h = p._init;
            try {
              return O(h(_));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var w = Object.assign, k = 0, ur, sr, cr, fr, lr, vr, dr;
    function hr() {
    }
    hr.__reactDisabledLog = !0;
    function Ut() {
      {
        if (k === 0) {
          ur = console.log, sr = console.info, cr = console.warn, fr = console.error, lr = console.group, vr = console.groupCollapsed, dr = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: hr,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        k++;
      }
    }
    function Jt() {
      {
        if (k--, k === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: w({}, e, {
              value: ur
            }),
            info: w({}, e, {
              value: sr
            }),
            warn: w({}, e, {
              value: cr
            }),
            error: w({}, e, {
              value: fr
            }),
            group: w({}, e, {
              value: lr
            }),
            groupCollapsed: w({}, e, {
              value: vr
            }),
            groupEnd: w({}, e, {
              value: dr
            })
          });
        }
        k < 0 && C("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Y = D.ReactCurrentDispatcher, U;
    function G(e, o, s) {
      {
        if (U === void 0)
          try {
            throw Error();
          } catch (p) {
            var l = p.stack.trim().match(/\n( *(at )?)/);
            U = l && l[1] || "";
          }
        return `
` + U + e;
      }
    }
    var J = !1, $;
    {
      var Bt = typeof WeakMap == "function" ? WeakMap : Map;
      $ = new Bt();
    }
    function pr(e, o) {
      if (!e || J)
        return "";
      {
        var s = $.get(e);
        if (s !== void 0)
          return s;
      }
      var l;
      J = !0;
      var p = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var _;
      _ = Y.current, Y.current = null, Ut();
      try {
        if (o) {
          var h = function() {
            throw Error();
          };
          if (Object.defineProperty(h.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(h, []);
            } catch (S) {
              l = S;
            }
            Reflect.construct(e, [], h);
          } else {
            try {
              h.call();
            } catch (S) {
              l = S;
            }
            e.call(h.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (S) {
            l = S;
          }
          e();
        }
      } catch (S) {
        if (S && l && typeof S.stack == "string") {
          for (var d = S.stack.split(`
`), R = l.stack.split(`
`), y = d.length - 1, b = R.length - 1; y >= 1 && b >= 0 && d[y] !== R[b]; )
            b--;
          for (; y >= 1 && b >= 0; y--, b--)
            if (d[y] !== R[b]) {
              if (y !== 1 || b !== 1)
                do
                  if (y--, b--, b < 0 || d[y] !== R[b]) {
                    var q = `
` + d[y].replace(" at new ", " at ");
                    return e.displayName && q.includes("<anonymous>") && (q = q.replace("<anonymous>", e.displayName)), typeof e == "function" && $.set(e, q), q;
                  }
                while (y >= 1 && b >= 0);
              break;
            }
        }
      } finally {
        J = !1, Y.current = _, Jt(), Error.prepareStackTrace = p;
      }
      var I = e ? e.displayName || e.name : "", j = I ? G(I) : "";
      return typeof e == "function" && $.set(e, j), j;
    }
    function Xt(e, o, s) {
      return pr(e, !1);
    }
    function Zt(e) {
      var o = e.prototype;
      return !!(o && o.isReactComponent);
    }
    function N(e, o, s) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return pr(e, Zt(e));
      if (typeof e == "string")
        return G(e);
      switch (e) {
        case g:
          return G("Suspense");
        case m:
          return G("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case v:
            return Xt(e.render);
          case T:
            return N(e.type, o, s);
          case E: {
            var l = e, p = l._payload, _ = l._init;
            try {
              return N(_(p), o, s);
            } catch {
            }
          }
        }
      return "";
    }
    var A = Object.prototype.hasOwnProperty, _r = {}, gr = D.ReactDebugCurrentFrame;
    function z(e) {
      if (e) {
        var o = e._owner, s = N(e.type, e._source, o ? o.type : null);
        gr.setExtraStackFrame(s);
      } else
        gr.setExtraStackFrame(null);
    }
    function Qt(e, o, s, l, p) {
      {
        var _ = Function.call.bind(A);
        for (var h in e)
          if (_(e, h)) {
            var d = void 0;
            try {
              if (typeof e[h] != "function") {
                var R = Error((l || "React class") + ": " + s + " type `" + h + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[h] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw R.name = "Invariant Violation", R;
              }
              d = e[h](o, h, l, s, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (y) {
              d = y;
            }
            d && !(d instanceof Error) && (z(p), C("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", l || "React class", s, h, typeof d), z(null)), d instanceof Error && !(d.message in _r) && (_r[d.message] = !0, z(p), C("Failed %s type: %s", s, d.message), z(null));
          }
      }
    }
    var ea = Array.isArray;
    function B(e) {
      return ea(e);
    }
    function ra(e) {
      {
        var o = typeof Symbol == "function" && Symbol.toStringTag, s = o && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return s;
      }
    }
    function ta(e) {
      try {
        return yr(e), !1;
      } catch {
        return !0;
      }
    }
    function yr(e) {
      return "" + e;
    }
    function br(e) {
      if (ta(e))
        return C("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ra(e)), yr(e);
    }
    var mr = D.ReactCurrentOwner, aa = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Cr, Rr;
    function na(e) {
      if (A.call(e, "ref")) {
        var o = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (o && o.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function ia(e) {
      if (A.call(e, "key")) {
        var o = Object.getOwnPropertyDescriptor(e, "key").get;
        if (o && o.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function oa(e, o) {
      typeof e.ref == "string" && mr.current;
    }
    function ua(e, o) {
      {
        var s = function() {
          Cr || (Cr = !0, C("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", o));
        };
        s.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: s,
          configurable: !0
        });
      }
    }
    function sa(e, o) {
      {
        var s = function() {
          Rr || (Rr = !0, C("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", o));
        };
        s.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: s,
          configurable: !0
        });
      }
    }
    var ca = function(e, o, s, l, p, _, h) {
      var d = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: e,
        key: o,
        ref: s,
        props: h,
        // Record the component responsible for creating this element.
        _owner: _
      };
      return d._store = {}, Object.defineProperty(d._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(d, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: l
      }), Object.defineProperty(d, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: p
      }), Object.freeze && (Object.freeze(d.props), Object.freeze(d)), d;
    };
    function fa(e, o, s, l, p) {
      {
        var _, h = {}, d = null, R = null;
        s !== void 0 && (br(s), d = "" + s), ia(o) && (br(o.key), d = "" + o.key), na(o) && (R = o.ref, oa(o, p));
        for (_ in o)
          A.call(o, _) && !aa.hasOwnProperty(_) && (h[_] = o[_]);
        if (e && e.defaultProps) {
          var y = e.defaultProps;
          for (_ in y)
            h[_] === void 0 && (h[_] = y[_]);
        }
        if (d || R) {
          var b = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          d && ua(h, b), R && sa(h, b);
        }
        return ca(e, d, R, p, l, mr.current, h);
      }
    }
    var X = D.ReactCurrentOwner, Sr = D.ReactDebugCurrentFrame;
    function x(e) {
      if (e) {
        var o = e._owner, s = N(e.type, e._source, o ? o.type : null);
        Sr.setExtraStackFrame(s);
      } else
        Sr.setExtraStackFrame(null);
    }
    var Z;
    Z = !1;
    function Q(e) {
      return typeof e == "object" && e !== null && e.$$typeof === t;
    }
    function Tr() {
      {
        if (X.current) {
          var e = O(X.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function la(e) {
      return "";
    }
    var Er = {};
    function va(e) {
      {
        var o = Tr();
        if (!o) {
          var s = typeof e == "string" ? e : e.displayName || e.name;
          s && (o = `

Check the top-level render call using <` + s + ">.");
        }
        return o;
      }
    }
    function qr(e, o) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var s = va(o);
        if (Er[s])
          return;
        Er[s] = !0;
        var l = "";
        e && e._owner && e._owner !== X.current && (l = " It was passed a child from " + O(e._owner.type) + "."), x(e), C('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', s, l), x(null);
      }
    }
    function Or(e, o) {
      {
        if (typeof e != "object")
          return;
        if (B(e))
          for (var s = 0; s < e.length; s++) {
            var l = e[s];
            Q(l) && qr(l, o);
          }
        else if (Q(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var p = $t(e);
          if (typeof p == "function" && p !== e.entries)
            for (var _ = p.call(e), h; !(h = _.next()).done; )
              Q(h.value) && qr(h.value, o);
        }
      }
    }
    function da(e) {
      {
        var o = e.type;
        if (o == null || typeof o == "string")
          return;
        var s;
        if (typeof o == "function")
          s = o.propTypes;
        else if (typeof o == "object" && (o.$$typeof === v || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        o.$$typeof === T))
          s = o.propTypes;
        else
          return;
        if (s) {
          var l = O(o);
          Qt(s, e.props, "prop", l, e);
        } else if (o.PropTypes !== void 0 && !Z) {
          Z = !0;
          var p = O(o);
          C("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", p || "Unknown");
        }
        typeof o.getDefaultProps == "function" && !o.getDefaultProps.isReactClassApproved && C("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function ha(e) {
      {
        for (var o = Object.keys(e.props), s = 0; s < o.length; s++) {
          var l = o[s];
          if (l !== "children" && l !== "key") {
            x(e), C("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", l), x(null);
            break;
          }
        }
        e.ref !== null && (x(e), C("Invalid attribute `ref` supplied to `React.Fragment`."), x(null));
      }
    }
    var wr = {};
    function jr(e, o, s, l, p, _) {
      {
        var h = Wt(e);
        if (!h) {
          var d = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (d += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var R = la();
          R ? d += R : d += Tr();
          var y;
          e === null ? y = "null" : B(e) ? y = "array" : e !== void 0 && e.$$typeof === t ? (y = "<" + (O(e.type) || "Unknown") + " />", d = " Did you accidentally export a JSX literal instead of a component?") : y = typeof e, C("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", y, d);
        }
        var b = fa(e, o, s, p, _);
        if (b == null)
          return b;
        if (h) {
          var q = o.children;
          if (q !== void 0)
            if (l)
              if (B(q)) {
                for (var I = 0; I < q.length; I++)
                  Or(q[I], e);
                Object.freeze && Object.freeze(q);
              } else
                C("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Or(q, e);
        }
        if (A.call(o, "key")) {
          var j = O(e), S = Object.keys(o).filter(function(ma) {
            return ma !== "key";
          }), ee = S.length > 0 ? "{key: someKey, " + S.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!wr[j + ee]) {
            var ba = S.length > 0 ? "{" + S.join(": ..., ") + ": ...}" : "{}";
            C(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, ee, j, ba, j), wr[j + ee] = !0;
          }
        }
        return e === i ? ha(b) : da(b), b;
      }
    }
    function pa(e, o, s) {
      return jr(e, o, s, !0);
    }
    function _a(e, o, s) {
      return jr(e, o, s, !1);
    }
    var ga = _a, ya = pa;
    M.Fragment = i, M.jsx = ga, M.jsxs = ya;
  }()), M;
}
var Dt;
function mn() {
  return Dt || (Dt = 1, process.env.NODE_ENV === "production" ? L.exports = yn() : L.exports = bn()), L.exports;
}
var Cn = mn();
const wn = ({ children: r, pageTitlePrefix: t, pathname: a }) => {
  const [i, u] = It(t), n = Sa(
    (c) => {
      u(() => `${c} | ${t}`);
    },
    [t]
  );
  return Pr(() => {
    u(t);
  }, [t, a]), Pr(() => {
    document.getElementsByTagName("title")[0].innerHTML = i;
  }, [i]), /* @__PURE__ */ Cn.jsx(Mt.Provider, { value: { setPageTitle: n }, children: r });
}, jn = (r, t) => {
  const [a, i] = It(() => {
    try {
      const n = window.localStorage.getItem(r);
      return n ? JSON.parse(n) : t;
    } catch (n) {
      return console.error(n), t;
    }
  });
  return [a, (n) => {
    try {
      const c = n instanceof Function ? n(a) : n;
      i(c), window.localStorage.setItem(r, JSON.stringify(c));
    } catch (c) {
      console.error(c);
    }
  }];
}, Rn = (r) => typeof r < "u" && r !== null && r !== "", Pn = (r) => Rn(r) ? /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
  r
) : !0;
export {
  Ea as GET_API_MODULE_NAMES,
  qa as LAYOUT_NAMES,
  Ta as PUT_API_MODULE_NAMES,
  wn as PageTitleProvider,
  Pn as email,
  Tn as getErrorMessage,
  qn as getUserId,
  En as getUserModules,
  jn as useLocalStorage,
  On as usePageTitle
};
//# sourceMappingURL=index.js.map
